import React from 'react';

function Frame({ children, title }) {
  return (
    <div className="dgw-illustration-frame" aria-label={title}>
      <svg viewBox="0 0 420 300" role="img" aria-hidden="true" className="dgw-illustration-svg">
        <defs>
          <linearGradient id="dgw-line" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#dbc7a0" />
            <stop offset="100%" stopColor="#7c8a9f" />
          </linearGradient>
          <linearGradient id="dgw-panel" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="rgba(255,255,255,0.16)" />
            <stop offset="100%" stopColor="rgba(255,255,255,0.04)" />
          </linearGradient>
        </defs>
        {children}
      </svg>
    </div>
  );
}

export function ShieldMeshIllustration() {
  return (
    <Frame title="DepGuard shield mesh illustration">
      <rect x="22" y="22" width="376" height="256" rx="28" className="dgw-illus-panel" />
      <path
        d="M210 66c26 20 56 30 88 34v54c0 56-33 98-88 126-55-28-88-70-88-126v-54c32-4 62-14 88-34Z"
        className="dgw-illus-shield"
      />
      <path d="M210 98v118" className="dgw-illus-line" />
      <path d="M158 154h104" className="dgw-illus-line" />
      <circle cx="210" cy="98" r="8" className="dgw-illus-node dgw-illus-node-gold" />
      <circle cx="158" cy="154" r="8" className="dgw-illus-node" />
      <circle cx="262" cy="154" r="8" className="dgw-illus-node" />
      <circle cx="210" cy="216" r="10" className="dgw-illus-node dgw-illus-node-dark" />
      <path d="M102 110h42" className="dgw-illus-line-soft" />
      <path d="M276 110h42" className="dgw-illus-line-soft" />
      <path d="M84 212h60" className="dgw-illus-line-soft" />
      <path d="M276 212h60" className="dgw-illus-line-soft" />
    </Frame>
  );
}

export function PlatformOrbitIllustration() {
  return (
    <Frame title="DepGuard platform orbit illustration">
      <rect x="22" y="22" width="376" height="256" rx="28" className="dgw-illus-panel" />
      <circle cx="210" cy="150" r="80" className="dgw-illus-orbit" />
      <circle cx="210" cy="150" r="48" className="dgw-illus-core" />
      <circle cx="210" cy="150" r="9" className="dgw-illus-node dgw-illus-node-gold" />
      <circle cx="210" cy="70" r="10" className="dgw-illus-node" />
      <circle cx="290" cy="150" r="10" className="dgw-illus-node" />
      <circle cx="210" cy="230" r="10" className="dgw-illus-node" />
      <circle cx="130" cy="150" r="10" className="dgw-illus-node" />
      <path d="M210 102v96" className="dgw-illus-line" />
      <path d="M162 150h96" className="dgw-illus-line" />
      <rect x="72" y="56" width="76" height="28" rx="14" className="dgw-illus-chip" />
      <rect x="272" y="56" width="76" height="28" rx="14" className="dgw-illus-chip" />
      <rect x="72" y="216" width="92" height="28" rx="14" className="dgw-illus-chip" />
      <rect x="256" y="216" width="92" height="28" rx="14" className="dgw-illus-chip" />
    </Frame>
  );
}

export function GovernanceRibbonIllustration() {
  return (
    <Frame title="DepGuard governance ribbon illustration">
      <rect x="22" y="22" width="376" height="256" rx="28" className="dgw-illus-panel" />
      <rect x="72" y="78" width="276" height="42" rx="18" className="dgw-illus-band" />
      <rect x="72" y="130" width="276" height="42" rx="18" className="dgw-illus-band dgw-illus-band-mid" />
      <rect x="72" y="182" width="276" height="42" rx="18" className="dgw-illus-band" />
      <circle cx="108" cy="99" r="9" className="dgw-illus-node dgw-illus-node-gold" />
      <circle cx="108" cy="151" r="9" className="dgw-illus-node" />
      <circle cx="108" cy="203" r="9" className="dgw-illus-node dgw-illus-node-dark" />
      <path d="M138 99h148" className="dgw-illus-line-soft" />
      <path d="M138 151h184" className="dgw-illus-line-soft" />
      <path d="M138 203h132" className="dgw-illus-line-soft" />
      <rect x="296" y="88" width="32" height="20" rx="10" className="dgw-illus-chip" />
      <rect x="312" y="140" width="16" height="20" rx="8" className="dgw-illus-chip" />
      <rect x="280" y="192" width="48" height="20" rx="10" className="dgw-illus-chip" />
    </Frame>
  );
}

export function TrustArchitectureIllustration() {
  return (
    <Frame title="DepGuard trust architecture illustration">
      <rect x="22" y="22" width="376" height="256" rx="28" className="dgw-illus-panel" />
      <path d="M82 220L210 82l128 138" className="dgw-illus-line" />
      <rect x="92" y="196" width="54" height="32" rx="12" className="dgw-illus-chip" />
      <rect x="184" y="146" width="52" height="34" rx="12" className="dgw-illus-chip" />
      <rect x="274" y="196" width="54" height="32" rx="12" className="dgw-illus-chip" />
      <circle cx="210" cy="82" r="12" className="dgw-illus-node dgw-illus-node-gold" />
      <circle cx="146" cy="152" r="8" className="dgw-illus-node" />
      <circle cx="274" cy="152" r="8" className="dgw-illus-node" />
      <path d="M110 98h48" className="dgw-illus-line-soft" />
      <path d="M262 98h48" className="dgw-illus-line-soft" />
      <path d="M176 236h68" className="dgw-illus-line-soft" />
    </Frame>
  );
}

export function KnowledgeSignalIllustration() {
  return (
    <Frame title="DepGuard knowledge signal illustration">
      <rect x="22" y="22" width="376" height="256" rx="28" className="dgw-illus-panel" />
      <rect x="78" y="70" width="112" height="148" rx="20" className="dgw-illus-band" />
      <rect x="230" y="82" width="112" height="58" rx="18" className="dgw-illus-band dgw-illus-band-mid" />
      <rect x="230" y="154" width="112" height="64" rx="18" className="dgw-illus-band" />
      <path d="M102 106h64" className="dgw-illus-line-soft" />
      <path d="M102 132h56" className="dgw-illus-line-soft" />
      <path d="M102 158h48" className="dgw-illus-line-soft" />
      <circle cx="284" cy="110" r="16" className="dgw-illus-node dgw-illus-node-gold" />
      <circle cx="270" cy="186" r="10" className="dgw-illus-node" />
      <circle cx="316" cy="186" r="10" className="dgw-illus-node dgw-illus-node-dark" />
      <path d="M270 186h46" className="dgw-illus-line" />
    </Frame>
  );
}

export function AnswerFlowIllustration() {
  return (
    <Frame title="DepGuard answer flow illustration">
      <rect x="22" y="22" width="376" height="256" rx="28" className="dgw-illus-panel" />
      <rect x="76" y="74" width="268" height="44" rx="18" className="dgw-illus-band" />
      <rect x="76" y="130" width="182" height="38" rx="16" className="dgw-illus-band dgw-illus-band-mid" />
      <rect x="76" y="182" width="132" height="30" rx="14" className="dgw-illus-chip" />
      <circle cx="304" cy="149" r="34" className="dgw-illus-core" />
      <path d="M292 149l9 9 16-20" className="dgw-illus-line" />
      <path d="M108 96h148" className="dgw-illus-line-soft" />
      <path d="M108 148h98" className="dgw-illus-line-soft" />
      <path d="M102 198h78" className="dgw-illus-line-soft" />
    </Frame>
  );
}

export function InsightDocumentIllustration() {
  return (
    <Frame title="DepGuard insight document illustration">
      <rect x="22" y="22" width="376" height="256" rx="28" className="dgw-illus-panel" />
      <path d="M120 58h126l54 54v130H120Z" className="dgw-illus-band" />
      <path d="M246 58v54h54" className="dgw-illus-line-soft" />
      <path d="M148 126h124" className="dgw-illus-line-soft" />
      <path d="M148 154h102" className="dgw-illus-line-soft" />
      <path d="M148 182h116" className="dgw-illus-line-soft" />
      <circle cx="310" cy="198" r="30" className="dgw-illus-node dgw-illus-node-gold" />
      <path d="M298 198l8 8 15-18" className="dgw-illus-line" />
    </Frame>
  );
}

export function ExecutiveBriefIllustration() {
  return (
    <Frame title="DepGuard executive brief illustration">
      <rect x="22" y="22" width="376" height="256" rx="28" className="dgw-illus-panel" />
      <rect x="62" y="70" width="296" height="38" rx="16" className="dgw-illus-band" />
      <rect x="62" y="126" width="132" height="92" rx="22" className="dgw-illus-band dgw-illus-band-mid" />
      <rect x="210" y="126" width="148" height="42" rx="18" className="dgw-illus-chip" />
      <rect x="210" y="178" width="148" height="40" rx="18" className="dgw-illus-band" />
      <path d="M92 89h162" className="dgw-illus-line-soft" />
      <circle cx="160" cy="170" r="28" className="dgw-illus-core" />
      <path d="M146 171l10 10 18-22" className="dgw-illus-line" />
      <path d="M232 147h90" className="dgw-illus-line-soft" />
      <path d="M232 198h76" className="dgw-illus-line-soft" />
    </Frame>
  );
}

export function BuyerJourneyIllustration() {
  return (
    <Frame title="DepGuard buyer journey illustration">
      <rect x="22" y="22" width="376" height="256" rx="28" className="dgw-illus-panel" />
      <path d="M70 210C130 206 138 148 186 142s63 48 110 34c27-8 44-38 56-78" className="dgw-illus-line" />
      <circle cx="86" cy="206" r="11" className="dgw-illus-node" />
      <circle cx="176" cy="146" r="11" className="dgw-illus-node" />
      <circle cx="262" cy="176" r="11" className="dgw-illus-node dgw-illus-node-gold" />
      <circle cx="340" cy="96" r="11" className="dgw-illus-node dgw-illus-node-dark" />
      <rect x="58" y="76" width="86" height="30" rx="15" className="dgw-illus-chip" />
      <rect x="164" y="58" width="104" height="30" rx="15" className="dgw-illus-band" />
      <rect x="284" y="56" width="76" height="30" rx="15" className="dgw-illus-band dgw-illus-band-mid" />
      <path d="M86 206V96" className="dgw-illus-line-soft" />
      <path d="M176 146V92" className="dgw-illus-line-soft" />
      <path d="M262 176v-54" className="dgw-illus-line-soft" />
    </Frame>
  );
}

export function EvidenceShowcaseIllustration() {
  return (
    <Frame title="DepGuard evidence showcase illustration">
      <rect x="22" y="22" width="376" height="256" rx="28" className="dgw-illus-panel" />
      <rect x="76" y="66" width="196" height="148" rx="24" className="dgw-illus-band" />
      <rect x="244" y="104" width="96" height="98" rx="22" className="dgw-illus-band dgw-illus-band-mid" />
      <path d="M104 104h134" className="dgw-illus-line-soft" />
      <path d="M104 132h118" className="dgw-illus-line-soft" />
      <path d="M104 160h126" className="dgw-illus-line-soft" />
      <rect x="104" y="182" width="78" height="20" rx="10" className="dgw-illus-chip" />
      <circle cx="292" cy="142" r="22" className="dgw-illus-core" />
      <circle cx="292" cy="184" r="10" className="dgw-illus-node dgw-illus-node-gold" />
      <path d="M282 143l7 7 14-17" className="dgw-illus-line" />
    </Frame>
  );
}

export function MarketSignalIllustration() {
  return (
    <Frame title="DepGuard market signal illustration">
      <rect x="22" y="22" width="376" height="256" rx="28" className="dgw-illus-panel" />
      <rect x="64" y="74" width="118" height="54" rx="18" className="dgw-illus-band" />
      <rect x="200" y="74" width="156" height="54" rx="18" className="dgw-illus-band dgw-illus-band-mid" />
      <rect x="64" y="146" width="292" height="84" rx="24" className="dgw-illus-chip" />
      <path d="M92 102h62" className="dgw-illus-line-soft" />
      <path d="M226 102h92" className="dgw-illus-line-soft" />
      <circle cx="122" cy="188" r="24" className="dgw-illus-core" />
      <circle cx="214" cy="188" r="11" className="dgw-illus-node" />
      <circle cx="266" cy="188" r="11" className="dgw-illus-node dgw-illus-node-gold" />
      <circle cx="318" cy="188" r="11" className="dgw-illus-node dgw-illus-node-dark" />
      <path d="M146 188h52" className="dgw-illus-line" />
      <path d="M225 188h30" className="dgw-illus-line" />
      <path d="M277 188h30" className="dgw-illus-line" />
    </Frame>
  );
}

/* ─── New Rich Illustrations ─────────────────────────────────────────── */

export function DepGuardDashboardIllustration() {
  const dims = [
    { label: 'Vulnerabilities', value: '3 CRITICAL', pct: 38,  color: '#ef4444' },
    { label: 'License Risk',    value: '2 at risk',  pct: 25,  color: '#f59e0b' },
    { label: 'Package Health',  value: 'Good',       pct: 82,  color: '#10b981' },
    { label: 'SBOM Quality',    value: 'Grade B+',   pct: 72,  color: '#6366f1' },
    { label: 'EU CRA',          value: '94%',        pct: 94,  color: '#8b5cf6' },
  ];
  /* Risk gauge: r=62, circ≈390, 72%≈281, top offset≈-97 */
  return (
    <svg viewBox="0 0 520 360" style={{width:'100%',maxHeight:360,display:'block'}} aria-label="DepGuard risk dashboard">
      {/* Window */}
      <rect x="0" y="0" width="520" height="360" rx="16" fill="#0f172a"/>
      <rect x="0" y="0" width="520" height="40" rx="16" fill="#1e293b"/>
      <rect x="0" y="28" width="520" height="12" fill="#1e293b"/>
      <circle cx="22" cy="20" r="5.5" fill="#ef4444" opacity="0.8"/>
      <circle cx="38" cy="20" r="5.5" fill="#f59e0b" opacity="0.8"/>
      <circle cx="54" cy="20" r="5.5" fill="#28ca41" opacity="0.8"/>
      <text x="260" y="24" textAnchor="middle" fontSize="11" fill="#64748b" fontFamily="monospace">depguard — Risk Analysis Dashboard</text>

      {/* Gauge background */}
      <circle cx="128" cy="198" r="62" fill="none" stroke="#1e293b" strokeWidth="12"/>
      {/* Track arc (270° = 3/4 circle) starting from ~-225° */}
      <circle cx="128" cy="198" r="62" fill="none" stroke="#263244" strokeWidth="12"
        strokeDasharray="294 95" strokeDashoffset="-49" strokeLinecap="round"/>
      {/* Fill arc: 72% of 294 = 212 */}
      <circle cx="128" cy="198" r="62" fill="none" stroke="#f59e0b" strokeWidth="12"
        strokeDasharray="212 178" strokeDashoffset="-49" strokeLinecap="round"/>
      {/* Score labels */}
      <text x="128" y="186" textAnchor="middle" fontSize="34" fontWeight="900" fill="#f1f5f9" fontFamily="system-ui,-apple-system,sans-serif">72</text>
      <text x="128" y="204" textAnchor="middle" fontSize="9.5" fill="#f59e0b" fontWeight="700" fontFamily="system-ui" letterSpacing="1">HIGH RISK</text>
      <text x="128" y="218" textAnchor="middle" fontSize="9" fill="#475569" fontFamily="system-ui">Overall Score</text>
      {/* Gauge glow */}
      <circle cx="128" cy="198" r="86" fill="rgba(245,158,11,0.04)"/>

      {/* Dimension rows */}
      {dims.map((d, i) => {
        const y = 58 + i * 52;
        return (
          <g key={d.label}>
            <rect x="222" y={y} width="282" height="44" rx="10" fill="#1e293b"/>
            <text x="237" y={y+18} fontSize="11" fill={d.color} fontWeight="700" fontFamily="system-ui">{d.label}</text>
            <text x="496" y={y+18} textAnchor="end" fontSize="11" fill={d.color} fontWeight="700" fontFamily="system-ui">{d.value}</text>
            {/* Progress bar */}
            <rect x="237" y={y+28} width="240" height="4" rx="2" fill="#0f172a"/>
            <rect x="237" y={y+28} width={240 * d.pct / 100} height="4" rx="2" fill={d.color} opacity="0.85"/>
          </g>
        );
      })}

      {/* Divider */}
      <line x1="22" y1="316" x2="498" y2="316" stroke="#1e293b" strokeWidth="1"/>
      <text x="22" y="334" fontSize="9.5" fill="#475569" fontFamily="monospace">Trend — 30 days</text>

      {/* Sparkline (rising) */}
      <polyline
        points="70,352 110,346 150,350 190,338 230,342 270,328 310,322 350,315 390,311 430,306 468,302"
        fill="none" stroke="#6366f1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="468" cy="302" r="4" fill="#6366f1"/>
      <text x="472" y="300" fontSize="9" fill="#6366f1" fontFamily="monospace">↗ improving</text>

      {/* Scan button */}
      <rect x="432" y="50" width="76" height="26" rx="7" fill="rgba(99,102,241,0.18)" stroke="rgba(99,102,241,0.4)" strokeWidth="1"/>
      <text x="470" y="67" textAnchor="middle" fontSize="10.5" fill="#a5b4fc" fontWeight="600" fontFamily="system-ui">⟳ Rescan</text>
    </svg>
  );
}

export function CrossProjectNetworkIllustration() {
  /* Center: (240,162). r=108 for surrounding nodes */
  const affected = [
    { cx: 348, cy: 162, label: 'api-gateway',  sub: 'Java'    },
    { cx: 316, cy: 238, label: 'auth-service', sub: 'Java'    },
    { cx: 240, cy: 270, label: 'user-service', sub: 'Node'    },
    { cx: 240,  cy: 54, label: 'orders-api',   sub: 'Java'    },
    { cx: 316,  cy: 86, label: 'payment-svc',  sub: 'Java'    },
  ];
  const safe = [
    { cx: 164, cy: 238, label: 'docs-site',  sub: 'HTML'   },
    { cx: 132, cy: 162, label: 'frontend',   sub: 'React'  },
    { cx: 164,  cy: 86, label: 'analytics',  sub: 'Python' },
  ];
  return (
    <svg viewBox="0 0 480 320" style={{width:'100%',maxHeight:320,display:'block'}} aria-label="Cross-project dependency impact graph">
      {/* Background gradient */}
      <defs>
        <radialGradient id="cpn-glow" cx="50%" cy="51%" r="30%">
          <stop offset="0%" stopColor="rgba(239,68,68,0.1)"/>
          <stop offset="100%" stopColor="rgba(239,68,68,0)"/>
        </radialGradient>
      </defs>
      <rect width="480" height="320" fill="#f8fafc"/>
      <circle cx="240" cy="162" r="130" fill="url(#cpn-glow)"/>

      {/* Lines to affected (red) */}
      {affected.map(n => (
        <line key={n.label} x1="240" y1="162" x2={n.cx} y2={n.cy}
          stroke="#ef4444" strokeWidth="1.8" opacity="0.5"/>
      ))}
      {/* Lines to safe (gray dashed) */}
      {safe.map(n => (
        <line key={n.label} x1="240" y1="162" x2={n.cx} y2={n.cy}
          stroke="#cbd5e1" strokeWidth="1.2" strokeDasharray="5 4"/>
      ))}

      {/* Affected nodes */}
      {affected.map(n => (
        <g key={n.label}>
          <circle cx={n.cx} cy={n.cy} r="26" fill="rgba(239,68,68,0.1)" stroke="#ef4444" strokeWidth="1.5"/>
          <text x={n.cx} y={n.cy-2} textAnchor="middle" fontSize="9.5" fill="#dc2626" fontWeight="700" fontFamily="system-ui">{n.label}</text>
          <text x={n.cx} y={n.cy+11} textAnchor="middle" fontSize="8" fill="#ef4444" fontFamily="system-ui">{n.sub}</text>
        </g>
      ))}

      {/* Safe nodes */}
      {safe.map(n => (
        <g key={n.label}>
          <circle cx={n.cx} cy={n.cy} r="24" fill="rgba(148,163,184,0.1)" stroke="#94a3b8" strokeWidth="1.2"/>
          <text x={n.cx} y={n.cy-1} textAnchor="middle" fontSize="9" fill="#64748b" fontWeight="600" fontFamily="system-ui">{n.label}</text>
          <text x={n.cx} y={n.cy+11} textAnchor="middle" fontSize="8" fill="#94a3b8" fontFamily="system-ui">{n.sub}</text>
        </g>
      ))}

      {/* Central vulnerable package */}
      <circle cx="240" cy="162" r="44" fill="rgba(239,68,68,0.12)" stroke="#ef4444" strokeWidth="2.5"/>
      <circle cx="240" cy="162" r="44" fill="none" stroke="rgba(239,68,68,0.25)" strokeWidth="8"/>
      <text x="240" y="156" textAnchor="middle" fontSize="12" fill="#dc2626" fontWeight="800" fontFamily="system-ui">⚠ log4j</text>
      <text x="240" y="172" textAnchor="middle" fontSize="10" fill="#ef4444" fontFamily="monospace">2.14.1</text>

      {/* Stats overlay */}
      <rect x="338" y="8" width="132" height="62" rx="10" fill="#1e293b" opacity="0.95"/>
      <text x="404" y="30" textAnchor="middle" fontSize="20" fill="#ef4444" fontWeight="900" fontFamily="system-ui">47</text>
      <text x="404" y="44" textAnchor="middle" fontSize="9.5" fill="#f87171" fontFamily="system-ui">projects affected</text>
      <text x="404" y="60" textAnchor="middle" fontSize="9" fill="#10b981" fontFamily="system-ui">3 not affected ✓</text>

      {/* Legend */}
      <circle cx="14" cy="300" r="5" fill="rgba(239,68,68,0.15)" stroke="#ef4444" strokeWidth="1.2"/>
      <text x="24" y="304" fontSize="9.5" fill="#64748b" fontFamily="system-ui">Affected by CVE</text>
      <circle cx="120" cy="300" r="5" fill="rgba(148,163,184,0.1)" stroke="#94a3b8" strokeWidth="1.2"/>
      <text x="130" y="304" fontSize="9.5" fill="#64748b" fontFamily="system-ui">Not affected</text>
    </svg>
  );
}

export function TaintFlowIllustration() {
  return (
    <svg viewBox="0 0 480 250" style={{width:'100%',maxHeight:250,display:'block'}} aria-label="PRISM taint analysis flow diagram">
      <rect width="480" height="250" fill="#f8fafc"/>

      {/* Header */}
      <text x="240" y="28" textAnchor="middle" fontSize="12" fill="#06b6d4" fontWeight="700" fontFamily="system-ui" letterSpacing="0.5">◈ PRISM — Taint Flow Detection</text>

      {/* === Source node === */}
      <rect x="16" y="58" width="138" height="68" rx="12" fill="rgba(16,185,129,0.08)" stroke="#10b981" strokeWidth="2"/>
      <text x="85" y="82" textAnchor="middle" fontSize="9.5" fill="#10b981" fontWeight="700" fontFamily="system-ui">◉ SOURCE</text>
      <text x="85" y="100" textAnchor="middle" fontSize="11.5" fill="#065f46" fontWeight="700" fontFamily="monospace">getUserInput()</text>
      <text x="85" y="116" textAnchor="middle" fontSize="9" fill="#10b981" fontFamily="system-ui">request.body</text>

      {/* Arrow 1 */}
      <line x1="154" y1="92" x2="172" y2="92" stroke="#f59e0b" strokeWidth="2"/>
      <polygon points="172,88 180,92 172,96" fill="#f59e0b"/>
      <text x="167" y="86" textAnchor="middle" fontSize="8" fill="#92400e" fontFamily="system-ui">taint</text>

      {/* === Flow node === */}
      <rect x="180" y="58" width="120" height="68" rx="12" fill="rgba(245,158,11,0.08)" stroke="#f59e0b" strokeWidth="2"/>
      <text x="240" y="82" textAnchor="middle" fontSize="9.5" fill="#f59e0b" fontWeight="700" fontFamily="system-ui">→ PROPAGATES</text>
      <text x="240" y="100" textAnchor="middle" fontSize="11.5" fill="#78350f" fontWeight="700" fontFamily="monospace">buildQuery()</text>
      <text x="240" y="116" textAnchor="middle" fontSize="9" fill="#f59e0b" fontFamily="system-ui">string concat</text>

      {/* Arrow 2 */}
      <line x1="300" y1="92" x2="318" y2="92" stroke="#ef4444" strokeWidth="2"/>
      <polygon points="318,88 326,92 318,96" fill="#ef4444"/>
      <text x="313" y="86" textAnchor="middle" fontSize="8" fill="#991b1b" fontFamily="system-ui">taint</text>

      {/* === Sink node === */}
      <rect x="326" y="58" width="138" height="68" rx="12" fill="rgba(239,68,68,0.08)" stroke="#ef4444" strokeWidth="2"/>
      <text x="395" y="82" textAnchor="middle" fontSize="9.5" fill="#ef4444" fontWeight="700" fontFamily="system-ui">✗ SINK</text>
      <text x="395" y="100" textAnchor="middle" fontSize="11.5" fill="#7f1d1d" fontWeight="700" fontFamily="monospace">executeSQL()</text>
      <text x="395" y="116" textAnchor="middle" fontSize="9" fill="#ef4444" fontFamily="system-ui">db.query call</text>

      {/* Missing sanitizer (dashed) */}
      <rect x="165" y="162" width="150" height="52" rx="12" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeDasharray="6 4"/>
      <text x="240" y="184" textAnchor="middle" fontSize="10" fill="#94a3b8" fontFamily="monospace">sanitize()</text>
      <text x="240" y="200" textAnchor="middle" fontSize="9" fill="#94a3b8" fontFamily="system-ui">NOT IN CODE PATH</text>

      {/* Dashed line from flow to sanitizer */}
      <line x1="240" y1="126" x2="240" y2="162" stroke="#94a3b8" strokeWidth="1.2" strokeDasharray="4 3"/>
      <text x="248" y="148" fontSize="8.5" fill="#94a3b8" fontFamily="system-ui">bypassed</text>

      {/* Warning banner */}
      <rect x="16" y="228" width="448" height="18" rx="6" fill="rgba(239,68,68,0.08)"/>
      <text x="240" y="241" textAnchor="middle" fontSize="9.5" fill="#dc2626" fontWeight="600" fontFamily="system-ui">
        ⚠ SQL Injection — CWE-89 — taint reaches sink without sanitization
      </text>
    </svg>
  );
}

export function VigilScanIllustration() {
  const lines = [
    { parts: [{ t:'❯ ', c:'#6366f1' }, { t:'vigil scan --rules ./rules --target ./src', c:'#e2e8f0' }] },
    { parts: [{ t:'◈ PRISM  ', c:'#22d3ee' }, { t:'Parsed 1,247 files in ', c:'#64748b' }, { t:'42ms', c:'#3fb950' }] },
    { parts: [{ t:'👁 Vigil  ', c:'#a78bfa' }, { t:'Running 140 PRL rules... ', c:'#64748b' }, { t:'done', c:'#3fb950' }] },
    { parts: [{ t:'─────────────────────────────────────────', c:'#21262d' }] },
    { parts: [{ t:'  ✗ CRITICAL  ', c:'#f85149' }, { t:'routes/login.ts:47', c:'#58a6ff' }, { t:'  SQL Injection [CWE-89]', c:'#8b949e' }] },
    { parts: [{ t:'    ↳ find flow from ', c:'#8b949e' }, { t:'@user_input', c:'#f0883e' }, { t:' to ', c:'#8b949e' }, { t:'@sql.execute', c:'#d2a8ff' }] },
    { parts: [{ t:'  ✗ HIGH      ', c:'#d29922' }, { t:'routes/userProfile.ts:120', c:'#58a6ff' }, { t:'  XSS [CWE-79]', c:'#8b949e' }] },
    { parts: [{ t:'    ↳ innerHTML = ', c:'#8b949e' }, { t:'req.body.bio', c:'#f0883e' }, { t:' (unsanitized)', c:'#f85149' }] },
    { parts: [{ t:'  ⚠ MEDIUM    ', c:'#d29922' }, { t:'lib/utils.ts:89', c:'#58a6ff' }, { t:'  Hardcoded secret', c:'#8b949e' }] },
    { parts: [{ t:'─────────────────────────────────────────', c:'#21262d' }] },
    { parts: [{ t:'  ✓ 3 findings ', c:'#3fb950' }, { t:'(1 CRITICAL, 1 HIGH, 1 MEDIUM)', c:'#8b949e' }] },
    { parts: [{ t:'  ✗ Policy gate: ', c:'#f85149' }, { t:'FAILED — critical threshold', c:'#f85149' }] },
  ];
  return (
    <svg viewBox="0 0 480 290" style={{width:'100%',maxHeight:290,display:'block'}} aria-label="Vigil scan results terminal">
      {/* Terminal window */}
      <rect x="0" y="0" width="480" height="290" rx="14" fill="#0d1117"/>
      <rect x="0" y="0" width="480" height="36" rx="14" fill="#161b22"/>
      <rect x="0" y="24" width="480" height="12" fill="#161b22"/>
      <circle cx="18" cy="18" r="5" fill="#ff5f57" opacity="0.85"/>
      <circle cx="32" cy="18" r="5" fill="#ffbd2e" opacity="0.85"/>
      <circle cx="46" cy="18" r="5" fill="#28ca41" opacity="0.85"/>
      <text x="240" y="22" textAnchor="middle" fontSize="10.5" fill="#8b949e" fontFamily="monospace">vigil — terminal</text>

      {/* Terminal content */}
      {lines.map((line, i) => {
        let x = 16;
        const y = 58 + i * 19;
        return (
          <text key={i} y={y} fontSize="10.5" fontFamily="monospace">
            {line.parts.map((p, j) => {
              const el = <tspan key={j} x={j === 0 ? x : undefined} fill={p.c}>{p.t}</tspan>;
              return el;
            })}
          </text>
        );
      })}

      {/* Speed badge */}
      <rect x="378" y="50" width="90" height="22" rx="7" fill="rgba(6,182,212,0.15)" stroke="rgba(6,182,212,0.3)" strokeWidth="1"/>
      <text x="423" y="65" textAnchor="middle" fontSize="9.5" fill="#22d3ee" fontWeight="700" fontFamily="system-ui">⚡ 42ms start</text>
    </svg>
  );
}
